import {objects} from "../models/objects";
import {object_extras} from "../models/object_extras";
import {requests, requestsCreationAttributes} from "../models/requests";
import {season_dates} from "../models/season_dates";
import {booking} from "../models/booking";

export const fetchItem = async (
	itemToFetch: string,
	searchparams: { searchKey: string } | {},
	locale?: string
) => {
	const searchParamsArray = Object.entries(searchparams);
	const url = new URL(
		`/api/${itemToFetch}`,
		typeof window !== "undefined"
			? window.origin
			: process.env.NEXT_PUBLIC_ENTRYPOINT
	);
	for (const [key, value] of searchParamsArray) {
		if (Array.isArray(value)) {
			for (const valueValue of value) {
				url.searchParams.append(key, valueValue);
			}
		} else {
			url.searchParams.append(key, value);
		}
	}
	let headers;
	if (locale) {
		headers = {
			"Accept-Language": locale
		};
	}
	const data = await fetch(url.toString(), {
		headers
	});
	return data.json();
};

export const postRequest = async (
	request: requestsCreationAttributes,
	locale = ""
) => {
	const url = new URL(
		"/api/requests",
		typeof window !== "undefined"
			? window.origin
			: process.env.NEXT_PUBLIC_ENTRYPOINT
	);
	const headers: any = {
		"Content-Type": "application/json"
	};
	if (locale !== "") {
		headers["accept-language"] = locale;
	}
	const data = await fetch(url.toString(), {
		method: "POST",
		headers,
		body: JSON.stringify(request)
	});
	return data.json();
};

export async function getObjectInServerSideProps(
	objectId: string | number,
	locale?: string
) {
	let headers;
	if (locale) {
		headers = {
			"Accept-Language": locale
		};
	}
	try {
		const response = await fetch(
			"http://next:3000/api/objects/" + objectId,
			{headers}
		);
		const object = await response.json();
		return JSON.stringify(object);
	} catch (error) {
	}
}

export async function getObject(objectId: string | number) {
	const response = await fetch("/api/objects/" + objectId);
	const object = await response.json();
	return object;
}

export async function getObjectExtras() {
	const data = await fetch("/api/extras");
	const extras = await data.json();
	return JSON.parse(extras) as object_extras[];
}

export async function getSeasonDates() {
	const data = await fetch("/api/seasondates");
	const seasonDates = await data.json();
	return JSON.parse(seasonDates) as season_dates[];
}

export async function getBookings(objectId: string) {
	const data = await fetch("/api/bookings?objectId=" + objectId);
	const bookings = await data.json();
	return JSON.parse(bookings) as booking[];
}
